// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SubscriptionStatus = function (x) {
    return x;
};
var tsBridgeSubscriptionStatu = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SubscriptionStatus")("__brandSubscriptionStatus"));
    }
};
var writeSubscriptionStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSubscriptionStatus = Data_Show.showString;
var readSubscriptionStatus = Simple_JSON.readString;
var ordSubscriptionStatus = Data_Ord.ordString;
var newtypeSubscriptionStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSubscriptionStatus = SubscriptionStatus;
var eqSubscriptionStatus = Data_Eq.eqString;
export {
    SubscriptionStatus,
    makeSubscriptionStatus,
    unwrap,
    newtypeSubscriptionStatus,
    eqSubscriptionStatus,
    ordSubscriptionStatus,
    showSubscriptionStatus,
    readSubscriptionStatus,
    writeSubscriptionStatus,
    tsBridgeSubscriptionStatu
};
//# sourceMappingURL=index.js.map
